<template>
    <div class="menu_wrapper">
        <div class="menu clearfix" v-if="lang === 'ru'">
            <span v-if="!isHeader">•</span>
            <router-link to="/" active-class="vis" exact><span :class="{m_arrow: isHeader}"></span>Главная</router-link>
            <span v-if="!isHeader">•</span>
            <router-link to="/portfolio" active-class="vis"><span :class="{m_arrow: isHeader}"></span>Мои работы</router-link>
            <span v-if="!isHeader">•</span>
            <router-link to="/about" active-class="vis"><span :class="{m_arrow: isHeader}"></span>О себе</router-link>
            <span v-if="!isHeader">•</span>
            <router-link to="/contacts" active-class="vis"><span :class="{m_arrow: isHeader}"></span>контакты</router-link>
            <span v-if="!isHeader">•</span>
        </div>
        <div class="menu clearfix" v-else>
            <span v-if="!isHeader">•</span>
            <router-link to="/" active-class="vis" exact><span :class="{m_arrow: isHeader}"></span>Home</router-link>
            <span v-if="!isHeader">•</span>
            <router-link to="/portfolio" active-class="vis"><span :class="{m_arrow: isHeader}"></span>Portfolio</router-link>
            <span v-if="!isHeader">•</span>
            <router-link to="/about" active-class="vis"><span :class="{m_arrow: isHeader}"></span>About me</router-link>
            <span v-if="!isHeader">•</span>
            <router-link to="/contacts" active-class="vis"><span :class="{m_arrow: isHeader}"></span>Contacts</router-link>
            <span v-if="!isHeader">•</span>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Menu',
  props: {
    lang: String,
    isHeader: Boolean,
  },
}
</script>
<style scoped>
</style>